/* ==========================================================================
   MINT BY MEMPHIS CO. — main.js
   Vanilla JS. No dependencies. Progressive enhancement only.
   ========================================================================== */

/* Shared lead-form routing: window.MBMForms lives in mbm-forms.js (loaded
   FIRST in layout/aurum.liquid). The inline duplicate that used to sit here
   was removed 2026-07-02: it overwrote the shared adapter on every homepage
   load and had already drifted (it lacked the contact endpoint). One source
   of truth now; edit assets/mbm-forms.js only. */

(function () {
  "use strict";
  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* --------------------------- Footer year ----------------------------- */
  const yearEl = $("#year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* --------------------------- Body scroll lock ------------------------- */
  let scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.body.style.overflow = scrollLocks > 0 ? "hidden" : "";
  }

  /* --------------------------- Announcement ----------------------------- */
  const announce = $("#announce");
  $("#announceClose")?.addEventListener("click", () => announce.classList.add("is-hidden"));

  /* --------------------------- Header scroll ---------------------------- */
  const header = $("#header");
  const stickyCta = $(".sticky-cta");
  const onScroll = () => {
    const y = window.scrollY;
    header.classList.toggle("is-scrolled", y > 30);
    if (stickyCta) stickyCta.classList.toggle("is-visible", y > 600);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* --------------------------- Mobile menu ------------------------------ */
  const menu = $("#mobileMenu");
  const openMenu = () => { menu.classList.add("is-open"); menu.setAttribute("aria-hidden", "false"); $("#menuOpen").setAttribute("aria-expanded", "true"); lockScroll(true); };
  const closeMenu = () => { menu.classList.remove("is-open"); menu.setAttribute("aria-hidden", "true"); $("#menuOpen").setAttribute("aria-expanded", "false"); lockScroll(false); };
  $("#menuOpen")?.addEventListener("click", openMenu);
  $("#menuClose")?.addEventListener("click", closeMenu);
  $$("#mobileMenu a").forEach((a) => a.addEventListener("click", closeMenu));

  /* --------------------------- Shop mega-menu --------------------------- */
  /* Hover is handled in CSS; this adds click (touch), keyboard, and Esc. */
  const shopItem = $("#shopMega");
  const shopTrigger = $("#shopTrigger");
  if (shopItem && shopTrigger) {
    const closeMega = () => { shopItem.classList.remove("is-open"); shopTrigger.setAttribute("aria-expanded", "false"); };
    shopTrigger.addEventListener("click", (e) => {
      e.preventDefault();
      const open = shopItem.classList.toggle("is-open");
      shopTrigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", (e) => { if (!shopItem.contains(e.target)) closeMega(); });
    shopItem.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeMega(); shopTrigger.focus(); } });
    $$(".mega a", shopItem).forEach((a) => a.addEventListener("click", closeMega));
  }

  /* --------------------------- Search overlay --------------------------- */
  const search = $("#searchOverlay");
  const openSearch = () => { search.classList.add("is-open"); search.setAttribute("aria-hidden", "false"); lockScroll(true); setTimeout(() => $("#searchInput")?.focus(), 300); };
  const closeSearch = () => { search.classList.remove("is-open"); search.setAttribute("aria-hidden", "true"); lockScroll(false); };
  $("#searchOpen")?.addEventListener("click", openSearch);
  $("#searchClose")?.addEventListener("click", closeSearch);
  $$(".chip").forEach((c) => c.addEventListener("click", () => { $("#searchInput").value = c.textContent; $("#searchInput").focus(); }));

  /* --------------------------- Cart drawer ------------------------------ */
  const drawer = $("#cartDrawer");
  const scrim = $("#drawerScrim");
  const openCart = () => { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); scrim.classList.add("is-open"); lockScroll(true); };
  const closeCart = () => { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); scrim.classList.remove("is-open"); lockScroll(false); };
  $("#cartBtn")?.addEventListener("click", () => { window.location.href = "/cart"; });
  $("#cartClose")?.addEventListener("click", closeCart);
  $("#cartShop")?.addEventListener("click", closeCart);
  scrim?.addEventListener("click", closeCart);

  /* --------------------------- Make an Offer ---------------------------- */
  const offerOverlay = $("#offerOverlay");
  /* Cloudflare Turnstile for the Make-an-Offer modal (rendered on open; token added in collect) */
  var OFFER_TS_SITEKEY = "0x4AAAAAADtEflh5kBgKCKOO", offerTsId = null;
  function renderOfferTS() {
    var box = document.getElementById("offerTurnstile");
    if (!box || offerTsId !== null) return;
    var n = 0;
    (function attempt() {
      if (window.turnstile && typeof window.turnstile.render === "function") {
        try { offerTsId = window.turnstile.render(box, { sitekey: OFFER_TS_SITEKEY, theme: "dark" }); } catch (e) {}
      } else if (n++ < 40) { setTimeout(attempt, 200); }
    })();
  }
  function offerTsToken() {
    try { return (window.turnstile && offerTsId !== null) ? (window.turnstile.getResponse(offerTsId) || "") : ""; }
    catch (e) { return ""; }
  }
  function openOffer(p) {
    if (!offerOverlay) return;
    $("#offerProduct").textContent = p.name;
    $("#offerPrice").textContent = fmt(p.price);
    $("#offerForm").hidden = false;
    $("#offerSuccess").hidden = true;
    offerOverlay.classList.add("is-open");
    offerOverlay.setAttribute("aria-hidden", "false");
    lockScroll(true);
    renderOfferTS();
    setTimeout(function () { var a = $("#offer-amount"); if (a) a.focus(); }, 250);
  }
  function closeOffer() {
    if (!offerOverlay || !offerOverlay.classList.contains("is-open")) return;
    offerOverlay.classList.remove("is-open");
    offerOverlay.setAttribute("aria-hidden", "true");
    lockScroll(false);
  }
  $("#offerClose")?.addEventListener("click", closeOffer);
  offerOverlay?.addEventListener("click", (e) => { if (e.target === offerOverlay) closeOffer(); });
  const offerForm = $("#offerForm");
  if (offerForm) {
    MBMForms.wire(offerForm, {
      subject: "New offer on a listed card (mintbymemphis.com)",
      kind: "offer",   /* routes to the Make Offer backend + offer confirmation copy */
      collect: () => {
        const amount = $("#offer-amount"), name = $("#offer-name"), email = $("#offer-email");
        const setE = (id, m) => { const el = $(`.field__error[data-for="${id}"]`); if (el) el.textContent = m || ""; };
        let ok = true;
        if (!amount.value || Number(amount.value) <= 0) { setE("offer-amount", "Enter your offer amount."); ok = false; } else setE("offer-amount", "");
        if (!name.value.trim()) { setE("offer-name", "Enter your name."); ok = false; } else setE("offer-name", "");
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) { setE("offer-email", "Enter a valid email."); ok = false; } else setE("offer-email", "");
        if (!ok) return null;
        return {
          Card: ($("#offerProduct")?.textContent || "").trim(),
          "Listed price": ($("#offerPrice")?.textContent || "").trim(),
          "Offer amount": "$" + amount.value,
          Name: name.value.trim(),
          Email: email.value.trim(),
          Message: ($("#offer-note")?.value || "").trim(),
          "cf-turnstile-response": offerTsToken()
        };
      },
      onSuccess: () => {
        offerForm.hidden = true;
        $("#offerSuccess").hidden = false;
        showToast("Offer submitted");
      }
    });
  }

  /* --------------------------- Global Esc ------------------------------- */
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeMenu(); closeSearch(); closeCart(); closeOffer();
  });

  /* --------------------------- Toast ------------------------------------ */
  const toast = $("#toast");
  let toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6"><path d="m5 13 4 4L19 7"/></svg>' + msg;
    toast.hidden = false;
    requestAnimationFrame(() => toast.classList.add("is-visible"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.classList.remove("is-visible");
      setTimeout(() => (toast.hidden = true), 400);
    }, 2600);
  }

  /* --------------------------- Cart badge (real Shopify cart) ----------- */
  function updateBadge(el, n) { if (!el) return; el.textContent = n; el.classList.toggle("is-zero", n === 0); }
  const cartCountEl = $("#cartCount");
  const cartCountText = $("#cartCountText");
  // Reflect the REAL Shopify cart count in the header badge (prototype mock/demo removed 2026-07-11).
  fetch("/cart.js", { headers: { Accept: "application/json" } })
    .then((r) => r.json())
    .then((c) => {
      updateBadge(cartCountEl, c.item_count);
      if (cartCountText) cartCountText.textContent = "(" + c.item_count + ")";
    })
    .catch(() => {});

  /* --------------------------- Reveal on scroll ------------------------- */
  const revealEls = $$(".reveal");
  if (revealEls.length) {
    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealEls.forEach((el) => el.classList.add("is-visible"));
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = parseInt(el.dataset.revealDelay || "0", 10);
          setTimeout(() => el.classList.add("is-visible"), delay);
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      revealEls.forEach((el) => io.observe(el));
    }
  }

  /* --------------------------- Count-up stats --------------------------- */
  const counters = $$("[data-count]");
  if (counters.length && "IntersectionObserver" in window) {
    const cio = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseInt(el.dataset.count, 10);
        const suffix = el.dataset.suffix || "";
        if (reduceMotion) { el.textContent = target.toLocaleString() + suffix; cio.unobserve(el); return; }
        const dur = 1600; const t0 = performance.now();
        const tick = (now) => {
          const p = Math.min(1, (now - t0) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        cio.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach((el) => cio.observe(el));
  }

  /* --------------------------- Testimonials ----------------------------- */
  const slides = $$(".testimonial");
  const dotsWrap = $("#testimonialDots");
  if (slides.length && dotsWrap) {
    let active = 0, timer;
    slides.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.setAttribute("role", "tab");
      dot.setAttribute("aria-label", "Testimonial " + (i + 1));
      if (i === 0) dot.classList.add("is-active");
      dot.addEventListener("click", () => { go(i); restart(); });
      dotsWrap.appendChild(dot);
    });
    const dots = $$("button", dotsWrap);
    function go(i) {
      slides[active].classList.remove("is-active");
      dots[active].classList.remove("is-active");
      active = (i + slides.length) % slides.length;
      slides[active].classList.add("is-active");
      dots[active].classList.add("is-active");
    }
    function restart() { if (reduceMotion) return; clearInterval(timer); timer = setInterval(() => go(active + 1), 6000); }
    restart();
    $("#tPrev")?.addEventListener("click", () => { go(active - 1); restart(); });
    $("#tNext")?.addEventListener("click", () => { go(active + 1); restart(); });
    const tWrap = $(".vault-review");
    tWrap?.addEventListener("mouseenter", () => clearInterval(timer));
    tWrap?.addEventListener("mouseleave", restart);
  }

  /* --------------------------- Sell form -------------------------------- */
  const sellForm = $("#sellForm");
  if (sellForm) {
    const setError = (id, msg) => {
      const field = $("#" + id).closest(".field");
      field.classList.toggle("is-error", !!msg);
      const err = $(`.field__error[data-for="${id}"]`);
      if (err) err.textContent = msg || "";
    };
    MBMForms.wire(sellForm, {
      subject: "New SELL lead: Get An Offer (homepage)",
      autoresponse: "Thank you for reaching out to Mint By Memphis. We have your details, and a real person (us, the family behind Mint By Memphis) will review your collection and reply within 24 hours, often sooner.\n\nTo get you the most accurate offer, just reply to this email with a few clear photos of your cards. The fronts of the key pieces, plus anything notable like grades or sealed product, are perfect.\n\nWe treat every collection like our own. Talk soon.\nMint By Memphis Co.",
      collect: () => {
        let ok = true;
        const name = $("#sf-name"), email = $("#sf-email"), type = $("#sf-type");
        if (!name.value.trim()) { setError("sf-name", "Please enter your name"); ok = false; } else setError("sf-name", "");
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) { setError("sf-email", "Please enter a valid email"); ok = false; } else setError("sf-email", "");
        if (!type.value) { setError("sf-type", "Please choose an option"); ok = false; } else setError("sf-type", "");
        if (!ok) return null;
        return {
          Name: name.value.trim(),
          Email: email.value.trim(),
          Phone: ($("#sf-phone")?.value || "").trim(),
          Selling: type.value,
          "Estimated value": ($("#sf-value")?.value || "").trim(),
          Message: ($("#sf-msg")?.value || "").trim()
        };
      },
      onSuccess: () => {
        $$(".field, .field-row, .sell-form__title, .sell-form__note, .sell-form .btn, .sell-form__trust", sellForm).forEach((el) => (el.style.display = "none"));
        $("#sellSuccess").hidden = false;
        showToast("Offer request sent");
      }
    });
  }

  /* --------------------------- Email form ------------------------------- */
  const emailForm = $("#emailForm");
  if (emailForm) {
    emailForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const input = $("#emailInput"), msg = $("#emailMsg");
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value)) { msg.textContent = "Please enter a valid email address."; msg.style.color = "#e08a72"; return; }
      const btn = emailForm.querySelector('button[type="submit"]');
      const label = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Joining…"; }
      msg.style.color = ""; msg.textContent = "";
      MBMForms.send("New newsletter signup (mintbymemphis.com)", { Email: input.value.trim(), Source: "Homepage Inner Circle signup" }, { autoresponse: "Welcome to the Inner Circle at Mint By Memphis. You will get first look at new inventory, premium cards, and market opportunities before they hit the public shop.\n\nMint By Memphis Co." }).then(() => {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        msg.style.color = ""; msg.textContent = "Welcome to the inner circle. We'll be in touch.";
        input.value = ""; showToast("You're on the list");
      }, () => {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        msg.style.color = "#e08a72";
        msg.innerHTML = "We couldn't add you just now. Email us at <a href=\"mailto:" + MBMForms.INBOX + "?subject=Newsletter%20signup\" style=\"color:var(--gold);text-decoration:underline\">" + MBMForms.INBOX + "</a> and we'll add you.";
      });
    });
  }

  /* ---- "Stay Close to the Vault" newsletter (descent d-stay) -----------
     The visible homepage newsletter. Same routing as the Inner Circle form
     above (the Inner Circle #email section is hidden in descent mode). */
  /* #stayForm now uses Shopify's native {% form 'customer' %} (real POST → creates a
     subscribed customer in Shopify Messaging). No JS interception, so the native submit
     is not treated as a scripted/bot request. Client-side email validation is handled by
     the input's type="email" + required attributes. */

  /* --------------------------- Hero image parallax ---------------------- */
  const heroTilt = document.getElementById("heroTilt");
  if (heroTilt && !reduceMotion && window.matchMedia("(pointer:fine)").matches) {
    let tx = 0, ty = 0, cx = 0, cy = 0, raf = 0;
    const tick = () => {
      cx += (tx - cx) * 0.07; cy += (ty - cy) * 0.07;
      heroTilt.style.setProperty("--ry", (cx * 10).toFixed(2) + "deg");
      heroTilt.style.setProperty("--rx", (-cy * 7).toFixed(2) + "deg");
      heroTilt.style.setProperty("--tx", (cx * 24).toFixed(1) + "px");
      heroTilt.style.setProperty("--ty", (cy * 16).toFixed(1) + "px");
      raf = (Math.abs(tx - cx) > 0.0005 || Math.abs(ty - cy) > 0.0005) ? requestAnimationFrame(tick) : 0;
    };
    window.addEventListener("pointermove", (e) => {
      tx = e.clientX / window.innerWidth - 0.5;
      ty = e.clientY / window.innerHeight - 0.5;
      if (!raf) raf = requestAnimationFrame(tick);
    }, { passive: true });
  }
})();

/* ---- Footer social row (single source, renders on every page) ---- */
(function () {
  var brand = document.querySelector(".footer__brand");
  if (!brand || brand.querySelector(".footer__social")) return;
  var items = [
    ["Instagram", "https://www.instagram.com/mintbymemphis", '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none"/></svg>'],
    ["TikTok", "https://www.tiktok.com/@mintbymemphis", '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M21 8.6a6.3 6.3 0 0 1-4.2-1.6v6.9a5.6 5.6 0 1 1-5.6-5.6c.3 0 .6 0 .9.06v2.8a2.8 2.8 0 1 0 2 2.7V2h2.7A4.6 4.6 0 0 0 21 6.1z"/></svg>'],
    ["Facebook", "https://www.facebook.com/p/Mint-by-Memphis-Co-61579333927491/", '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M14 8.6V7c0-.8.5-1 1-1h2V3h-3c-2.3 0-3.6 1.3-3.6 3.7V8.6H8v3h2.4V21H14v-9.4h2.6l.4-3z"/></svg>']
  ];
  var row = document.createElement("div");
  row.className = "footer__social";
  items.forEach(function (it) {
    var a = document.createElement("a");
    a.href = it[1];
    a.target = "_blank";
    a.rel = "noopener";
    a.setAttribute("aria-label", it[0]);
    a.innerHTML = it[2];
    row.appendChild(a);
  });
  brand.appendChild(row);
})();

/* ---- Quiet footer trust line (single source, renders on every page) ---- */
(function () {
  var bottom = document.querySelector(".footer__bottom");
  if (!bottom || document.querySelector(".footer__trust")) return;
  var el = document.createElement("p");
  el.className = "footer__trust container";
  el.style.cssText = "text-align:center;color:var(--text-mute);font-size:.78rem;letter-spacing:.07em;margin:0 auto 1.1rem";
  el.innerHTML = '1,200+ Positive eBay Reviews <span style="color:var(--gold)">·</span> Family-Owned <span style="color:var(--gold)">·</span> Est. 2025';
  bottom.parentNode.insertBefore(el, bottom);
})();

/* ---- Living vault: custom cursor + cursor-follow spotlight (desktop only) ---- */
(function () {
  if (!window.matchMedia("(pointer: fine)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var spot = document.createElement("div"); spot.className = "vault-spot";
  var dot = document.createElement("div"); dot.className = "cur cur--dot";
  var ring = document.createElement("div"); ring.className = "cur cur--ring";
  var label = document.createElement("span"); label.className = "cur__label"; ring.appendChild(label);
  document.body.appendChild(spot); document.body.appendChild(dot); document.body.appendChild(ring);
  document.documentElement.classList.add("has-cursor");

  var mx = window.innerWidth / 2, my = window.innerHeight / 2, rx = mx, ry = my;

  window.addEventListener("pointermove", function (e) {
    mx = e.clientX; my = e.clientY;
    dot.style.transform = "translate(" + mx + "px," + my + "px)";
    document.body.classList.add("has-spot");
    spot.style.setProperty("--mx", mx + "px");
    spot.style.setProperty("--my", my + "px");
  }, { passive: true });

  (function loop() {
    rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
    ring.style.transform = "translate(" + rx + "px," + ry + "px)";
    requestAnimationFrame(loop);
  })();

  window.addEventListener("pointerover", function (e) {
    var t = e.target;
    ring.classList.remove("is-hover", "is-flip", "is-view");
    label.textContent = "";
    dot.style.opacity = ""; ring.style.opacity = "";
    if (!t || !t.closest) return;
    if (t.closest("input, textarea, select")) { dot.style.opacity = "0"; ring.style.opacity = "0"; return; }
    if (t.closest("#heroCanvas")) { ring.classList.add("is-flip"); label.textContent = "Explore"; return; }
    if (t.closest(".product")) { ring.classList.add("is-view"); label.textContent = "View"; return; }
    if (t.closest("a, button, .btn, label, [data-cursor]")) { ring.classList.add("is-hover"); return; }
  }, { passive: true });

  document.addEventListener("mouseleave", function () { dot.style.opacity = "0"; ring.style.opacity = "0"; });
  document.addEventListener("mouseenter", function () { dot.style.opacity = ""; ring.style.opacity = ""; });
})();

/* ---- Header "Contact Us" button + contact popup (single source, every page) ---- */
(function () {
  var EMAIL = "mintbymemphis@gmail.com";
  var MAILTO = "mailto:" + EMAIL + "?subject=Question%20for%20Mint%20By%20Memphis";

  // Scoped body-scroll lock: this IIFE cannot see the header IIFE's lockScroll(),
  // so openContact/closeContact threw "lockScroll is not defined". Define a local one.
  var contactScrollLocks = 0;
  function lockScroll(on) {
    contactScrollLocks = Math.max(0, contactScrollLocks + (on ? 1 : -1));
    document.body.style.overflow = contactScrollLocks > 0 ? "hidden" : "";
  }

  // Relabel the nav "Contact" link to "Contact Us" (next to About) and open the form.
  // No separate header button, so there is no duplicate.
  var navA = document.querySelectorAll(".nav a, .footer a");
  for (var n = 0; n < navA.length; n++) {
    var ctxt = navA[n].textContent.trim().toLowerCase();
    if (ctxt === "contact" || ctxt === "contact us") {
      navA[n].textContent = "Contact Us";
      navA[n].setAttribute("data-contact", "");
      navA[n].setAttribute("href", "#");
    }
  }

  var ov = document.createElement("div");
  ov.className = "contact-overlay";
  ov.id = "contactOverlay";
  ov.setAttribute("aria-hidden", "true");
  ov.innerHTML =
    '<div class="contact-modal" role="dialog" aria-modal="true" aria-label="Contact us">' +
      '<button class="contact-modal__close icon-btn" id="contactClose" aria-label="Close"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      '<span class="eyebrow eyebrow--center">Get in Touch</span>' +
      '<h3 class="contact-modal__title">Contact Us</h3>' +
      '<p class="contact-modal__text">Tell us a bit about what you would like to discuss, and a real person (us) will get back to you fast.</p>' +
      '<form id="contactForm" novalidate>' +
        '<div class="field"><label for="c-name">Name</label><input id="c-name" name="name" type="text" autocomplete="name" required /><span class="field__error" data-for="c-name"></span></div>' +
        '<div class="field"><label for="c-email">Email</label><input id="c-email" name="email" type="email" autocomplete="email" required /><span class="field__error" data-for="c-email"></span></div>' +
        '<div class="field"><label for="c-msg">What would you like to discuss?</label><textarea id="c-msg" name="message" rows="3" required placeholder="A card, an order, selling a collection..."></textarea><span class="field__error" data-for="c-msg"></span></div>' +
        '<div id="contactTurnstile" style="margin:0 0 12px; display:flex; justify-content:center;"></div>' +
        '<button class="btn btn--gold btn--block" type="submit">Send Message</button>' +
      '</form>' +
      '<p class="contact-modal__note">Prefer email? <a href="' + MAILTO + '">' + EMAIL + '</a></p>' +
      '<div class="contact-modal__success" id="contactSuccess" hidden role="status"><svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m8 12 3 3 5-6"/></svg><h3>Message sent</h3><p>Thank you. We will get back to you within 24 hours.</p></div>' +
    '</div>';
  document.body.appendChild(ov);

  var contactToken = null;   /* Turnstile mounts on first open (reveal-render) */
  function openContact() {
    ov.classList.add("is-open"); ov.setAttribute("aria-hidden", "false"); lockScroll(true);
    if (!contactToken && window.MBMForms && MBMForms.turnstileMount) contactToken = MBMForms.turnstileMount(document.getElementById("contactTurnstile"));
  }
  function closeContact() { if (!ov.classList.contains("is-open")) return; ov.classList.remove("is-open"); ov.setAttribute("aria-hidden", "true"); lockScroll(false); }

  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var trigger = e.target.closest("[data-contact]");
    if (trigger && !trigger.closest(".contact-modal")) { e.preventDefault(); openContact(); return; }
    if (e.target === ov) closeContact();
  });
  document.getElementById("contactClose").addEventListener("click", closeContact);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeContact(); });
  MBMForms.wire(document.getElementById("contactForm"), {
    subject: "New contact message (mintbymemphis.com)",
    kind: "contact",   /* Turnstile-protected Basin form 71602 */
    autoresponse: "Thanks for reaching out to Mint By Memphis. We have your message, and a real person will get back to you within 24 hours.\n\nMint By Memphis Co.",
    collect: function () {
      var name = document.getElementById("c-name"), email = document.getElementById("c-email"), msg = document.getElementById("c-msg");
      var setE = function (id, m) { var el = document.querySelector('.field__error[data-for="' + id + '"]'); if (el) el.textContent = m || ""; };
      var ok = true;
      if (!name.value.trim()) { setE("c-name", "Please enter your name."); ok = false; } else setE("c-name", "");
      if (!MBMForms.emailValid(email.value)) { setE("c-email", "Please enter a valid email."); ok = false; } else setE("c-email", "");
      if (!msg.value.trim()) { setE("c-msg", "Please add a brief note."); ok = false; } else setE("c-msg", "");
      if (!ok) return null;
      return { Name: name.value.trim(), Email: email.value.trim(), Message: msg.value.trim(), "cf-turnstile-response": contactToken ? contactToken() : "" };
    },
    onSuccess: function () {
      document.getElementById("contactForm").hidden = true;
      document.getElementById("contactSuccess").hidden = false;
    }
  });
})();

/* ----------------- Persistent "Get an Offer" CTA (FAB) ----------------- */
/* One-tap path to the valuation form from any page, so seller and blog
   traffic always has the acquisition CTA in reach. Same-page smooth-scroll
   when a form exists; otherwise links to the sell hub. */
(function () {
  var doc = document;
  if (doc.querySelector(".offer-fab")) return; // never duplicate

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var localEl = doc.querySelector("#review") || doc.querySelector("#sell");
  var isLocal = !!localEl;
  var href = isLocal ? "#" + localEl.id : "sell.html#review";

  var fab = doc.createElement("a");
  fab.className = "offer-fab";
  fab.href = href;
  fab.setAttribute("aria-label", "Get a free, no-obligation offer on your cards");
  fab.innerHTML =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 2.8 12V5a2 2 0 0 1 2-2h7a2 2 0 0 1 1.4.6l7.4 7.4a2 2 0 0 1 0 2.8z"/>' +
    '<circle cx="7.6" cy="7.6" r="1.4"/></svg>' +
    '<span>Get an Offer</span>';

  // Suppress this FAB on phones ONLY where a VISIBLE Shop/Sell bar exists (inner pages).
  // The homepage hides .sticky-cta via descent-mode, so the FAB must stay on mobile there.
  if (doc.querySelector(".sticky-cta") && !doc.body.classList.contains("descent-mode")) fab.classList.add("offer-fab--with-bar");

  doc.body.appendChild(fab);

  /* On the AURUM page the canonical acquisition path is the Get an Offer flow.
     Prefer it at click time (checked here, not at injection, because the flow
     script loads after this one). Other pages have no MBMPresent, so they keep
     the original scroll/navigate behavior untouched. */
  fab.addEventListener("click", function (e) {
    // Homepage: send the FAB INTO the acquisition room (the room is the submission
    // point); the in-room "Get an Offer" is what opens the intake flow.
    if (window.MBMVault && typeof window.MBMVault.enter === "function") {
      e.preventDefault();
      window.MBMVault.enter("sell");
      return;
    }
    if (window.MBMPresent && typeof window.MBMPresent.open === "function") {
      e.preventDefault();
      window.MBMPresent.open(fab);
      return;
    }
    if (isLocal) {
      e.preventDefault();
      localEl.scrollIntoView({ behavior: prefersReduced ? "auto" : "smooth", block: "start" });
      var field = localEl.querySelector("input, select, textarea");
      if (field) setTimeout(function () { try { field.focus({ preventScroll: true }); } catch (_) { field.focus(); } }, prefersReduced ? 0 : 520);
    }
  });

  var revealed = false, targetInView = false;
  function update() {
    var show = window.scrollY > 480 && !targetInView;
    if (show !== revealed) { revealed = show; fab.classList.toggle("is-visible", show); }
  }
  if (isLocal && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      targetInView = entries[0].isIntersecting;
      update();
    }, { rootMargin: "0px 0px -35% 0px" }).observe(localEl);
  }
  window.addEventListener("scroll", update, { passive: true });
  update();
})();

/* ----------------------------- Private Vault --------------------------- */
/* "Enter the Vault" opens the door panels once, then reveals the inventory.
   Lot "Inquire" buttons prefill + scroll to the inquiry form. No walls.
   Both vault forms route through the shared MBMForms router. */
(function () {
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var R = window.MBMForms;
  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ""; }
  function mark(el, bad) { if (!el) return; var f = el.closest(".vault-field"); if (f) f.classList.toggle("is-error", bad); }

  /* ---- door: open once, then reveal inventory ---- */
  var stage = document.getElementById("vaultStage");
  if (stage) {
    var enter = document.getElementById("enterVault");
    var inv = document.getElementById("vault-inventory");
    if (enter) enter.addEventListener("click", function () {
      stage.classList.add("is-open");
      setTimeout(function () { if (inv) inv.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" }); }, reduced ? 0 : 950);
    });
  }

  /* ---- lot "Inquire" buttons prefill the inquiry form ---- */
  document.querySelectorAll("[data-inquire]").forEach(function (b) {
    b.addEventListener("click", function () {
      var itemField = document.getElementById("vi-item");
      if (itemField) itemField.value = b.getAttribute("data-inquire");
      var sec = document.getElementById("vault-inquiry");
      if (sec) sec.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
      var nm = document.getElementById("vi-name");
      if (nm) setTimeout(function () { try { nm.focus({ preventScroll: true }); } catch (e) { nm.focus(); } }, reduced ? 0 : 650);
    });
  });

  if (!R) return;

  /* ---- inquiry form (ask about a specific piece) ---- */
  R.wire(document.getElementById("vaultInquiryForm"), {
    subject: "New Private Vault inquiry (mintbymemphis.com)",
    autoresponse: "Thank you for your inquiry to The Private Vault at Mint By Memphis. A real person will reply within 24 hours with full details and a fair current price. Always discreet, and never any obligation.\n\nMint By Memphis Co.",
    collect: function () {
      var name = document.getElementById("vi-name");
      var email = document.getElementById("vi-email");
      if (!name) return null;
      var ok = true;
      var bn = !name.value.trim(); mark(name, bn); if (bn) ok = false;
      var be = !R.emailValid(email.value); mark(email, be); if (be) ok = false;
      if (!ok) return null;
      return {
        Name: name.value.trim(),
        Email: email.value.trim(),
        Phone: val("vi-phone"),
        "Piece of interest": val("vi-item"),
        "Looking for": val("vi-message"),
        "Notify on new pieces": (document.getElementById("vi-optin") || {}).checked ? "Yes" : "No"
      };
    },
    onSuccess: function () {
      var f = document.getElementById("vaultInquiryForm"); f.hidden = true;
      var s = document.getElementById("vaultSuccess"); if (s) { s.hidden = false; s.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "center" }); }
    }
  });

  /* ---- private client interest list (relationship, not a wall) ---- */
  var pc = document.getElementById("pcForm");
  if (pc) {
    pc.querySelectorAll('input[name="role"]').forEach(function (r) {
      r.addEventListener("change", function () { var fs = r.closest(".pc-seg-field"); if (fs) fs.classList.remove("is-error"); });
    });
    R.wire(pc, {
      subject: "New Private Client List signup (mintbymemphis.com)",
      autoresponse: "Thank you for joining the Private Client List at Mint By Memphis. We have your collecting interests, and we will reach out personally when a piece fits what you collect. No spam, and we never share your details.\n\nMint By Memphis Co.",
      collect: function () {
        var name = document.getElementById("pc-name");
        var email = document.getElementById("pc-email");
        var coll = document.getElementById("pc-collect");
        var ok = true;
        var bn = !name.value.trim(); mark(name, bn); if (bn) ok = false;
        var be = !R.emailValid(email.value); mark(email, be); if (be) ok = false;
        var bc = !coll.value.trim(); mark(coll, bc); if (bc) ok = false;
        var role = pc.querySelector('input[name="role"]:checked');
        var roleWrap = document.getElementById("pc-role");
        roleWrap = roleWrap ? roleWrap.closest(".pc-seg-field") : null;
        if (roleWrap) roleWrap.classList.toggle("is-error", !role);
        if (!role) ok = false;
        if (!ok) return null;
        var contact = pc.querySelector('input[name="contact"]:checked');
        return {
          Name: name.value.trim(),
          Email: email.value.trim(),
          Collects: coll.value.trim(),
          Hunting: val("pc-hunting"),
          "Buyer / Seller": role.value,
          Phone: val("pc-phone"),
          "Preferred contact": contact ? contact.value : "Email"
        };
      },
      onSuccess: function () {
        pc.hidden = true;
        var s = document.getElementById("pcSuccess"); if (s) { s.hidden = false; s.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "center" }); }
      }
    });
  }
})();
